<template>
  <Modal v-model="visible" :title="title" :footer-hide="true" :mask-closable="false" width="99%"
    class="my-modal top">
    <div class="search-tools">
      <div class="search-box btn3" :class="{ 'close': !searchMore }">
        <div class="input-item">
          <span class="label">供应商</span>
          <span class="text">{{statementData.supplierName}}</span>
        </div>
        <div class="input-item" v-if="statementData.supplierType == 2">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyCode" clearable filterable transfer>
            <Option v-for="(bean, i) in companyLists" :key="i" :value="bean.code">{{ bean.name }}</Option>
          </Select>
        </div>
        <div class="input-item" v-if="this.statementData.reconciliationType == 4||this.statementData.reconciliationType == 5">
          <span class="label">保单年度</span>
          <Input v-model="searchParams.commissionIndex" placeholder="请输入正整数" type="number" @on-change="changeValue('commissionIndex')" />        
        </div>
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item" v-if="this.statementData.reconciliationType == 4||this.statementData.reconciliationType == 5">
          <span class="label" style="width:105px;">交费期次</span>
          <Input v-model="searchParams.commissionPeriods" placeholder="请输入正整数" type="number" @on-change="changeValue('commissionPeriods')" />
        </div>
        <div class="input-item select-two" v-if="this.statementData.reconciliationType == 1||this.statementData.reconciliationType == 2 || this.statementData.reconciliationType == 3">
          <Select v-model="searchParams.dateType" :transfer="true" @on-change="changeDateType">
            <Option value="1">投保日期</Option>
            <Option value="2">支付日期</Option>
            <Option value="3">承保日期</Option>
            <Option value="4">生效日期</Option>
          </Select>
          <DatePicker v-model="searchParams.date" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime"></DatePicker>
        </div>
        <div class="input-item select-two" v-if="this.statementData.reconciliationType == 4||this.statementData.reconciliationType == 5">
          <Select v-model="searchParams.dateType" :transfer="true" @on-change="changeDateType">
            <Option value="1">投保日期</Option>
            <Option value="3">承保日期</Option>
            <Option value="4">生效日期</Option>
          </Select>
          <DatePicker v-model="searchParams.date" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime"></DatePicker>
        </div>
        <div class="input-item select-two" v-if="this.statementData.reconciliationType == 4||this.statementData.reconciliationType == 5">
          <Select v-model="searchParams.dateType2" :transfer="true" @on-change="changeDateType2">
            <Option value="1">应收日期</Option>
            <Option value="2">宽限期满日</Option>
          </Select>
          <DatePicker v-model="searchParams.date1" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime5"></DatePicker>
        </div>
        <div class="input-item" v-if="this.statementData.reconciliationType == 4||this.statementData.reconciliationType == 5">
          <span class="label">实收日期</span>
          <DatePicker v-model="searchParams.actualReceiveTime" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime6"></DatePicker>
        </div>
        <div class="input-item" v-if="this.statementData.reconciliationType == 4||this.statementData.reconciliationType == 5">
          <span class="label">退保日期</span>
          <DatePicker v-model="searchParams.refundTime" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime4" :disabled="searchParams.isNull3"></DatePicker>
            <Checkbox v-model="searchParams.isNull3" class="null" @on-change="changeDateNull">为空</Checkbox>
        </div>
        <div class="input-item">
          <span class="label">保单号</span>
          <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">保单状态</span>
          <Select v-model="searchParams.policyStatusList" :transfer="true" clearable multiple>
            <Option value="1">已承保</Option>
            <Option value="-1">已退保</Option>
            <Option value="0">已终止</Option>
          </Select>
        </div>
        <div class="input-item" v-if="this.statementData.reconciliationType == 1||this.statementData.reconciliationType == 2 || this.statementData.reconciliationType == 3">
          <span class="label">回执状态</span>
          <lzDicSelect v-model="searchParams.receiptStatusList" dicType="RECEIPT_STATUS" :transfer="true" clearable multiple :disabled="searchParams.receiptStatusNull">
          </lzDicSelect>
          <Checkbox v-model="searchParams.receiptStatusNull" class="null" @on-change="changeTypeNull">为空</Checkbox>
        </div>
        <div class="input-item select-two select-two1" v-if="this.statementData.reconciliationType == 1||this.statementData.reconciliationType == 2 || this.statementData.reconciliationType == 3">
          <Select v-model="searchParams.dateType1" :transfer="true" @on-change="changeDateType1">
            <Option value="1">回执签收日期</Option>
            <Option value="2">回执回销日期</Option>
          </Select>
          <DatePicker v-model="searchParams.date1" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime1" :disabled="searchParams.isNull"></DatePicker>
            <Checkbox v-model="searchParams.isNull" class="null" @on-change="changeDateNull">为空</Checkbox>
        </div>
        <div class="input-item" v-if="this.statementData.reconciliationType == 1||this.statementData.reconciliationType == 2 || this.statementData.reconciliationType == 3">
          <span class="label">回访状态</span>
          <lzDicSelect v-model="searchParams.verifyStatusList" dicType="VERIFY_STATUS" :transfer="true" multiple clearable :disabled="searchParams.verifyStatusNull">
          </lzDicSelect>
          <Checkbox v-model="searchParams.verifyStatusNull" class="null" @on-change="changeTypeNull">为空</Checkbox>
        </div>
        <div class="input-item" v-if="this.statementData.reconciliationType == 1||this.statementData.reconciliationType == 2 || this.statementData.reconciliationType == 3">
          <span class="label">回访日期</span>
          <DatePicker v-model="searchParams.revisitDate" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime2" :disabled="searchParams.isNull1"></DatePicker>
            <Checkbox v-model="searchParams.isNull1" class="null" @on-change="changeDateNull">为空</Checkbox>
        </div>
        <div class="input-item" v-if="this.statementData.reconciliationType == 1||this.statementData.reconciliationType == 2 || this.statementData.reconciliationType == 3">
          <span class="label">犹豫止期</span>
          <DatePicker v-model="searchParams.hesitateDate" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime3" :disabled="searchParams.isNull2"></DatePicker>
            <Checkbox v-model="searchParams.isNull2" class="null" @on-change="changeDateNull">为空</Checkbox>
        </div>
        <div class="input-item" v-if="this.statementData.reconciliationType == 1||this.statementData.reconciliationType == 2 || this.statementData.reconciliationType == 3">
          <span class="label">退保日期</span>
          <DatePicker v-model="searchParams.refundTime" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime4" :disabled="searchParams.isNull3"></DatePicker>
            <Checkbox v-model="searchParams.isNull3" class="null" @on-change="changeDateNull">为空</Checkbox>
        </div>
        <div class="input-item" v-if="this.statementData.reconciliationType == 1||this.statementData.reconciliationType == 2 || this.statementData.reconciliationType == 3">
          <span class="label">是否代收费</span>
          <RadioGroup v-model="searchParams.isCollection" @on-change="getList()">
            <Radio label="">全部</Radio>
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">险种分类</span>
          <Select v-model="searchParams.themeIds" clearable filterable multiple :transfer="true">
            <Option v-for="(item, index) in themeList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">业务类别</span>
          <Select v-model="searchParams.sellType" :transfer="true" clearable :disabled="searchParams.sellTypeNull">
            <Option value="1">网销</Option>
            <Option value="3">经代</Option>
          </Select>
          <Checkbox v-model="searchParams.sellTypeNull" class="null" @on-change="changeTypeNull">为空</Checkbox>
        </div>
        <div class="input-item" v-if="this.statementData.reconciliationType == 1||this.statementData.reconciliationType == 2 || this.statementData.reconciliationType == 3">
            <span class="label">长短险标志</span>
            <RadioGroup v-model="searchParams.productType" @on-change="getList()">
                <Radio label="">全部</Radio>
                <Radio label="1">长险</Radio>
                <Radio label="2">短险</Radio>
            </RadioGroup>
        </div>
        <div class="input-item">
          <span class="label">出单机构/团队</span>
          <selectTree type="1" v-model="searchParams.applyOrgId" @change="selectTreeChange" ref="selectTree"></selectTree>
        </div>
        <div class="input-item">
          <span class="label">出单业务员</span>
          <Select clearable v-model="searchParams.salesmanId" style="width:256px;" filterable :transfer="true">
            <Option :value="item.id" v-for="(item, index) in salesmanList" :key="index"
              :label="item.staffNo + (item.staffNo ? '/' : '') + item.name"></Option>
          </Select>
        </div>
        <div class="input-item" v-if="this.statementData.reconciliationType == 1">
          <span class="label">费用类型</span>
          <Select v-model="searchParams.commissionType" clearable>
            <Option value="1">基础费用</Option>
            <Option value="2">限时加费活动</Option>
          </Select>
        </div>
        <div class="input-item" v-if="statementData.reconciliationType == 4">
          <span class="label">费用类型</span>
          <Select v-model="searchParams.commissionType" clearable>
            <Option value="3">续期基础费用</Option>
            <Option value="4">续年度服务津贴</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">是否扣款记录</span>
          <RadioGroup v-model="searchParams.queryDeduct" @on-change="searchAjax">
            <Radio label="">全部</Radio>
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="pageNo=1;getList()">查询</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false">收起
            <Icon type="ios-arrow-up" />
          </Button>
          <Button type="primary" ghost v-else @click="searchMore = true">展开
            <Icon type="ios-arrow-down" />
          </Button>
        </div>
      </div>
    </div>
    <div style="margin-bottom: 10px;">*按照对账类型显示默认的保单数据，条件检索后更新保单列表；<span style="color: red;">如选择已在其他对账单的记录，将会自动将该条记录从原对账单剔除。</span></div>

    <div class="tools-box">
      <div class="left-box">
        <Checkbox v-model="isAll" @on-change="selectAll">全部</Checkbox>
      </div>
      <div class="right-box">
        <span class="text">已选择<span>{{ isAll ? total : ids.length }}</span>项,共<span>{{ total }}</span>记录</span>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData" class="table" @on-selection-change="selectionChange">
      </Table>
    </div>
    <div class="pageBox">
      <Page :total="total" :current="pageNo" :page-size="pageSize" show-total @on-change="pageChange"
        style="text-align: center" />
    </div>
    <div class="ivu-modal-footer">
      <Button type="text" @click="cancel">取消</Button>
      <Button type="primary" @click="addStatement">加入对账单</Button>
    </div>
  </Modal>
</template>

<script>
import selectTree from "@/components/system/selectTree3";
import { pageTool } from "@/api/mixins";
import lzDicSelect from "@/components/commons/lzDicSelect";
import { config } from './getStatementModel.js';
import filter from "@/api/filter";
export default {
  mixins: [pageTool,config],
  components: { lzDicSelect, selectTree, },
  data() {
    return {
      visible: false,
      isAll: false,
      pageNo: 1,
      title:'',
      ids: [],
      checkId: '',
      salesmanList: [], // 业务员
      supplierList: [], // 供应商
      companyLists: [], //保险公司列表
      themeList: [],
      reconcitiation:'',
      reconcitiationData:{},
      searchParams: {
        dateType: '3',
        isCollection: '',
        dateType1: '1',
        dateType2: '1'
      },
      statementData:{},
    }
  },
  mounted() {
    this.getOrganizationUser()
    this.queryTheme();
    this.geCompanyList();
  },
  methods: {
    // 获取对账类型列表
    getReconcitiation(val){
      this.reconcitiationData = JSON.parse(localStorage.dic)["RECONCILIATION_TYPE"]
      this.reconcitiation = this.reconcitiationData[val]
      if(this.statementData.agreementName){
        this.title =  '请选择本账单包含的保单（来源：'+this.statementData.supplierName+this.reconcitiation+ '，协议：'+ this.statementData.agreementName+')'
      }else{
        this.title =  '请选择本账单包含的保单（来源：'+this.statementData.supplierName+this.reconcitiation+')'
      }
      
    },
    detail(id) {
      this.$http({
        url: "/buz/commissionReconciliation/read/detail",
        type: "GET",
        data: { id: id },
      }).then((res) => {
        this.statementData = res.data
        this.getReconcitiation(res.data.reconciliationType)
        this.getList()
        this.getColumns()
      });
    },
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.ids = [];
    },
    changeValue(value){
      this.searchParams[value] = this.searchParams[value].replace(/^0(0+)|[^\d]+/g, '') 
      this.searchParams[value] = this.searchParams[value] && Number(this.searchParams[value])
      return this.searchParams[value]
    },
    // 获取列表数据
    getList() {
      this.listLoading = true;
      this.searchParams.supplierId = this.statementData.supplierId
      this.$http({
        url: "/buz/commissionReconciliation/policy/result",
        type: "post",
        data: {
          ...this.searchParams,
          tab: '1',
          isFirst: 1,
          checkId:this.checkId,
          pageNo: this.pageNo,
          specialCondition:1,
          pageSize: this.pageSize,
        }
      }).then(res => {
        res.data.forEach(item => {
          this.ids.forEach(item2 => {
            if (item.id == item2) {
              item._checked = true;
            }
          })
          if (this.isAll) {
            item._checked = true;
            item._disabled = true;
          }
        })
        this.tableData = res.data;
        this.total = res.total;
      }).finally(e => {
        this.listLoading = false;
      });
    },
    // 加入对账单
    addStatement() {
      if (this.ids && this.ids.length > 0 || this.isAll) {
        this.$http({
          url: `/buz/molCommissionConsult/batchAdd`,
          type: "POST",
          data: {
            checkId: this.checkId,
            ids: this.ids,
            isAll: this.isAll,
            commissionLogQuery: this.searchParams
          }
        }).then((res) => {
          this.ids = [];
          this.visible = false
          this.$emit('getList')
        })
      } else {
        this.$notice.msg("请至少选择一个保单")
      }
    },
    selectionChange(rows) {
      const pageIds = rows.map(item => item.id); //当前页勾选的
      const selectIds = this.ids.map(item => item); //已经添加的数据
      this.tableData.forEach(item => {
        if (pageIds.includes(item.id) && !selectIds.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.ids.push(item.id);
          selectIds.push(item.id);
        } else if (!pageIds.includes(item.id) && selectIds.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.ids.splice(selectIds.indexOf(item.id), 1);
          selectIds.splice(selectIds.indexOf(item.id), 1);
        }
      });
    },
    open(id) {
      this.visible = true
      this.checkId = id
      this.tableData = []
      this.searchParams= {
        dateType: '3',
        isCollection: '',
        dateType1:'1',
        dateType2:'1'
      }
      this.isAll = false
      this.initListAjax("/buz/commissionReconciliation/policy/result");
      this.detail(id)
    },
    cancel() {
      this.visible = false
      this.ids = [];
    },
    changeTypeNull(){
      if(this.searchParams.sellTypeNull){
        this.searchParams.sellType=''
        this.searchParams.sellTypeIsNull = '1'
      }else{
        this.searchParams.sellTypeIsNull = ''
      }

      if(this.searchParams.reconciliationNull){
        this.searchParams.reconciliationId = ''
        this.searchParams.reconciliationIdIsNull = '1'
      }else{
        this.searchParams.reconciliationIdIsNull = ''
      }
      
      if(this.searchParams.receiptStatusNull){
        this.searchParams.receiptStatusList = []
        this.searchParams.receiptStatusIsNull = '1'
      }else{
        this.searchParams.receiptStatusIsNull = ''
      }

      if(this.searchParams.verifyStatusNull){
        this.searchParams.verifyStatusList = []
        this.searchParams.verifyStatusIsNull = '1'
      }else{
        this.searchParams.verifyStatusIsNull = ''
      }
    },
    // 各项日期处理
    changeDateType(){
        this.searchParams.date = []
        this.searchParams.holdTimeStart = '';
        this.searchParams.holdTimeEnd = '';

        this.searchParams.payTimeStart = '';
        this.searchParams.payTimeEnd = '';

        this.searchParams.insureTimeStart = '';
        this.searchParams.insureTimeEnd = '';

        this.searchParams.effectTimeStart = '';
        this.searchParams.effectTimeEnd	 = '';
    },
    changeDateType1(){
        this.searchParams.date1 = []
        this.searchParams.receiptDate2Start = '';
        this.searchParams.receiptDate2End	 = '';

        this.searchParams.receiptDateStart = '';
        this.searchParams.receiptDateEnd	 = '';

        this.changeDateNull()
    },
    changeDateType2(){
      this.searchParams.dateType2 = []
      this.searchParams.receivableTimeStart = '';
      this.searchParams.receivableTimeEnd	 = '';

      this.searchParams.lastPayDateStart = '';
      this.searchParams.lastPayDateEnd	= '';
    },
    changeTime(time) {
      if(this.searchParams.dateType == '1'){
        this.searchParams.holdTimeStart = time[0];
        this.searchParams.holdTimeEnd = time[1];
      }else if(this.searchParams.dateType == '2'){
        this.searchParams.payTimeStart = time[0];
        this.searchParams.payTimeEnd = time[1];
      }else if(this.searchParams.dateType == '3'){
        this.searchParams.insureTimeStart = time[0];
        this.searchParams.insureTimeEnd = time[1];
      }else if(this.searchParams.dateType == '4'){
        this.searchParams.effectTimeStart = time[0];
        this.searchParams.effectTimeEnd	 = time[1];
      }
    },
    changeTime1(time) {
      if(this.searchParams.dateType1 == '1'){
        this.searchParams.receiptDate2Start = time[0];
        this.searchParams.receiptDate2End	 = time[1];
      }else if(this.searchParams.dateType1 == '2'){
        this.searchParams.receiptDateStart = time[0];
        this.searchParams.receiptDateEnd	 = time[1];
      }
    },
    changeTime2(time) {
      this.searchParams.revisitDateStart = time[0];
      this.searchParams.revisitDatEnd	 = time[1];
    },
    changeTime3(time) {
      this.searchParams.hesitateDateStart = time[0];
      this.searchParams.hesitateDateEnd	 = time[1];
    },
    changeTime4(time) {
      this.searchParams.refundTimeStart = time[0];
      this.searchParams.refundTimeEnd	 = time[1];
    },
    changeTime5(time) {
      if(this.searchParams.dateType1 == '1'){
        this.searchParams.receivableTimeStart = time[0];
        this.searchParams.receivableTimeEnd	 = time[1];
      }else if(this.searchParams.dateType1 == '2'){
        this.searchParams.lastPayDateStart = time[0];
        this.searchParams.lastPayDateEnd	 = time[1];
      }
    },
    changeTime6(time) {
      this.searchParams.actualReceiveTimeStart = time[0];
      this.searchParams.actualReceiveTimeEnd	 = time[1];
    },

    changeDateNull(){
      if(this.searchParams.isNull){
        this.searchParams.date1 = []
        if(this.searchParams.dateType1=='1'){
          this.searchParams.receiptDate2Start = ''
          this.searchParams.receiptDate2End	 = ''

          this.searchParams.receiptDateIsNull = ''
          this.searchParams.receiptDate2IsNull = '1'
        }else if(this.searchParams.dateType1=='2'){
          this.searchParams.receiptDateStart = ''
          this.searchParams.receiptDateEnd	 = ''
          
          this.searchParams.receiptDate2IsNull = ''
          this.searchParams.receiptDateIsNull = '1'
        }
      }else{
        this.searchParams.receiptDate2IsNull = ''
        this.searchParams.receiptDateIsNull = ''
      }

      if(this.searchParams.isNull1){
        this.searchParams.revisitDate = []
        this.searchParams.revisitDateStart = ''
        this.searchParams.revisitDatEnd	 = ''
        this.searchParams.revisitDateIsNull = '1'
      }else{
        this.searchParams.revisitDateIsNull = ''
      }

      if(this.searchParams.isNull2){
        this.searchParams.hesitateDate = []
        this.searchParams.hesitateDateStart = ''
        this.searchParams.hesitateDateEnd	 = ''
        this.searchParams.hesitateDateIsNull = '1'
      }else{
        this.searchParams.hesitateDateIsNull = ''
      }

      if(this.searchParams.isNull3){
        this.searchParams.refundTime = []
        this.searchParams.refundTimeStart = ''
        this.searchParams.refundTimeEnd	 = ''
        this.searchParams.refundTimeIsNull = '1'
      }else{
        this.searchParams.refundTimeIsNull = ''
      }


    },
    // 分页
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getList();
    },
    // 产品业务分类
    queryTheme() {
      this.$http({
        url: '/buz/productTheme/array/first',
        type: 'GET'
      }).then(res => {
        this.themeList = res.data;
      });
    },
    // 通过机构获取业务员
    getOrganizationUser(id) {
      this.$http({
        url: `/buz/userBase/getByOrgIds`,
        type: "POST",
        data: {
          orgaList: id ? [id] : []
        }
      }).then((res) => {
        this.salesmanList = res.data;
      })
    },
    // 机构树选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {
        //机构
        this.searchParams.policyOrgId = data.id;
        this.searchParams.groupId = "";
      } else if (data.nodeType == 2) {
        //团队
        this.searchParams.policyOrgId = "";
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.policyOrgId = "";
        this.searchParams.groupId = "";
      }
    },
    //列表保险公司
    geCompanyList() {
      let url = "/buz/insuranceCompany/read/list";
      this.$http({
        url: url,
        type: "POST",
        data: { companyType: "1" }
      }).then((res) => {
        //赠险公司列表初始化
        this.companyLists = res.data;
      });
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.searchParams.supplierIds;
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/all'
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list'
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then((res) => {
          this.supplierList = res.data;
        })
      }
      this.getList();
    },
  }
}
</script>

<style lang="scss" scoped>
.null{
  padding-left: 10px;
  line-height: 30px;
  white-space: nowrap;
}
.tip-icon {
    margin-left: 3px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #9c9c9c;
    color: #a8a6a6;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
  .tip-icon:hover + .pop-tip {
    opacity: 0.9;
    z-index: 9999;
    display: block;
  }
/deep/ .ivu-modal-wrap .ivu-modal{
  top: 5vh!important;
}
/deep/.input-item.select-two.select-two1>:nth-child(1){
    width: 114px!important;
}
/deep/ .ivu-modal-footer{
  z-index: 1000 !important;
}
.search-tools {
  margin-top: 20px;
}
/deep/ .ivu-modal-header-inner{
  height: 40px;
  line-height: 40px;
}
/deep/ .ivu-modal-body{
  padding-top: 10px !important;
}
.table {
  margin-top: 20px;
}

.pageBox {
  margin-top: 10px;
}

/deep/ .ivu-table-tip table {
  min-height: 380px;
}

/deep/ .tip-icon {
  margin-left: 3px;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: transparent;
  border: 1px solid #ccc;
  color: #ccc;
  display: inline-block;
  text-align: center;
  line-height: 14px;
  font-size: 14px;
  cursor: pointer;
  top: 50%;
}

.text{
  line-height: 30px;
}
</style>